import { defineFetch } from 'resift';

const makePostFilterGetUserCount = defineFetch({
  displayName: 'Post Filter Get User Count',
  make: () => ({
    request: (filter: any) => async ({ http }) => {
      const response = await http({
        method: 'POST',
        route: '/search/user',
        data: { filter, pageSize: 0, useAggregateCounts: false },
      });

      return response.totalLength;
    },
  }),
});

export default makePostFilterGetUserCount;
